currentSelectedVehicle = fitmentData.currentVehicle

const modalMobile = document.getElementById('fitment_modal_mobile')
const btnMobile = document.getElementById('fitment_btn_mobile')
const spanMobile = document.querySelector('.close_mobile')

btnMobile.onclick = function () {
  modalMobile.style.display = 'block'

  window.kortx('ktrack', 'submitLead', {
    contentId: 'Lead',
    contentType: 'Select my Ride',
    kid: '35071488$1728522', // DO NOT EDIT
  })
}

spanMobile.onclick = function () {
  modalMobile.style.display = 'none'
}

function processFitmentsMobile(currentSelectedVehicle) {
  let param = ''
  let info = ''

  for (const [key, value] of Object.entries(currentSelectedVehicle)) {
    if (key === 'year') {
      getFitmentsMobile('').then((data) => {
        if (Object.keys(data.result).length > 0) {
          const sortedYears = data.result.year.sort((a, b) => b - a) // Sort years in descending order
          makeFitmentSelectShared(
            Object.keys(data.result)[0],
            sortedYears,
            value,
            true
          )
        }
      })
      param = `${key}=${value}`
    } else {
      getFitmentsMobile(param).then((data) => {
        if (
          Object.keys(data.result).length > 0 &&
          Object.keys(data.result)[0] !== 'sku'
        ) {
          makeFitmentSelectShared(
            Object.keys(data.result)[0],
            data.result[Object.keys(data.result)[0]],
            value,
            true
          )
        }
      })
      param += `&${key}=${value}`
    }

    info += `${value} `
  }

  const fitmentHeaderMobile = document.querySelector(
    '.fitment_header_mobile strong'
  )
  fitmentHeaderMobile.textContent = info.trim()
  fitmentHeaderMobile.style.fontSize = '13px'

  const fitmentBtnMobile = document.getElementById('fitment_btn_mobile')
  fitmentBtnMobile.textContent = 'Change'
  fitmentBtnMobile.disabled = false

  document.querySelector('.fitment_shop_btn_mobile').disabled = false
  document.querySelector('.fitment_clear_btn_mobile').style.display = 'block'

  fitmentData.currentVehicle = currentSelectedVehicle
  saveFitmentData()
}

if (isEmpty(currentSelectedVehicle)) {
  const fitmentHeaderMobile = document.querySelector(
    '.fitment_header_mobile strong'
  )
  const fitmentBtnMobile = document.getElementById('fitment_btn_mobile')

  fitmentHeaderMobile.textContent = 'Shop by vehicle'
  fitmentHeaderMobile.style.fontSize = '15px'
  fitmentBtnMobile.textContent = '+ select my ride'
  fitmentBtnMobile.disabled = false

  getFitmentsMobile('').then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeFitmentSelectShared(
        Object.keys(data.result)[0],
        data.result.year.sort((a, b) => b - a),
        '',
        true
      )
    }
  })
} else {
  processFitmentsMobile(currentSelectedVehicle)
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

async function getFitmentsMobile(param) {
  const store_id = 'bds'
  let url = `https://fitmentapi.azurewebsites.net/api/ymm?store_id=${store_id}`

  if (param) {
    if (!param.startsWith('&')) {
      param = '&' + param
    }
    url += param
  }

  // Check if we have cached data for this param
  if (fitmentData.dropdownData[param]) {
    return { result: fitmentData.dropdownData[param] }
  }

  const res = await fetch(url, { method: 'GET' })
  const data = await res.json()

  // Cache the result
  fitmentData.dropdownData[param] = data.result
  fitmentData.lastUpdated = new Date().getTime()
  saveFitmentData()

  return data
}

function saveFitmentData() {
  localStorage.setItem('fitmentData', JSON.stringify(fitmentData))
}

function getFitmentData() {
  const storedData = localStorage.getItem('fitmentData')
  if (storedData) {
    const parsedData = JSON.parse(storedData)
    const now = new Date().getTime()
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000

    if (now - parsedData.lastUpdated < threeDaysInMs) {
      return parsedData
    }
  }
  return null
}

// The rest of the functions (makeFitmentSelectMobile, makeFitmentParamMobile, etc.) remain largely unchanged

$(document).on('change', '.fitment_select_mobile', function () {
  const validSelectArr = [
    'year',
    'make',
    'model',
    'submodel',
    'drive_type',
    'fuel_type',
    'doors',
  ]

  const id = $(this).attr('id').replace('_mobile', '')

  if (validSelectArr.includes(id)) {
    currentSelectedVehicle[id] = $(this).val()
    fitmentData.currentVehicle = currentSelectedVehicle
    saveFitmentData()

    getFitmentsMobile(makeFitmentParamMobile(id)).then((data) => {
      const resultKeys = Object.keys(data.result)
      const resultLength = resultKeys.length

      if (
        resultLength > 0 &&
        resultKeys[0] !== 'doors' &&
        resultKeys[0] !== 'type' &&
        data.result[resultKeys[0]].length > 0
      ) {
        makeFitmentSelectShared(
          resultKeys[0],
          data.result[resultKeys[0]],
          '',
          true
        )
        document.querySelector('.fitment_shop_btn_mobile').disabled = true
        document.querySelector('.fitment_clear_btn_mobile').style.display =
          'none'
      } else {
        document.querySelector('.fitment_shop_btn_mobile').disabled = false
        document.querySelector('.fitment_clear_btn_mobile').style.display =
          'block'
      }
    })
  }
})

let fitmentShopBtnMobile = document.querySelector('.fitment_shop_btn_mobile')
if (fitmentShopBtnMobile) {
  fitmentShopBtnMobile.addEventListener('click', function () {
    let info = ''
    for (const [k, v] of Object.entries(currentSelectedVehicle)) {
      info += v + ' '
    }

    document.querySelector('.fitment_info').textContent = info
    const header = document.querySelector('.collection_details_header h1')
    if (header) header.textContent = info + ' All Products'
    document.querySelector('.fitment_info_container').style.display = 'block'
    document.querySelector('.fitment_header').style.display = 'none'
    document.querySelector('.fitment_header_mobile strong').textContent = info
    document.getElementById('fitment_btn_mobile').textContent = 'Change'

    fitmentData.currentVehicle = currentSelectedVehicle
    saveFitmentData()

    modalMobile.style.display = 'none'

    if (!window.location.href.includes('/collections/') && !window.location.href.includes('/products/') && !window.location.href.includes('search?q=')) {
      window.location.href = '/pages/product-fitment-search'
    } else {
      location.reload()
    }
  })
}

function makeFitmentParamMobile(type) {
  let param = ''
  let isAdding = true
  let keyArray = []
  for (const [k, v] of Object.entries(currentSelectedVehicle)) {
    if (isAdding) {
      param += k + '=' + v + '&'
      keyArray.push(k)
    } else {
      delete currentSelectedVehicle[k]
    }
    if (k == type) {
      isAdding = false
    }
  }
  document.querySelectorAll('.fitment_select_mobile').forEach((element) => {
    if (!keyArray.includes(element.id.replace('_mobile', ''))) {
      let id = element.id.replace('_mobile', '')
      if (id == 'make' || id == 'model') {
        document
          .getElementById(id + '_mobile')
          .querySelectorAll('option:not(:first-child)')
          .forEach((option) => option.remove())
        document.getElementById(id + '_mobile').disabled = true
      } else {
        element.remove()
      }
    }
  })

  return param.slice(0, -1)
}

function clearFitmentDataMobile() {
  fitmentData = {
    currentVehicle: {},
    dropdownData: {},
    lastUpdated: null,
  }
  currentSelectedVehicle = {}
  saveFitmentData()

  document.querySelector('.fitment_info').textContent = ''
  document.querySelector('.fitment_info_container').style.display = 'none'
  document.querySelector('.fitment_header_mobile strong').textContent =
    'Shop by vehicle'
  document.getElementById('fitment_btn_mobile').textContent = '+ select my ride'
  document.querySelector('.fitment_header').style.display = 'block'

  document.querySelectorAll('.fitment_select_mobile').forEach((el) => {
    const id = el.id.replace('_mobile', '')
    if (id == 'year' || id == 'make' || id == 'model') {
      document.getElementById(id + '_mobile').innerHTML = ''
      document.getElementById(id + '_mobile').disabled = true
    } else {
      el.remove()
    }
  })

  getFitmentsMobile('').then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeFitmentSelectShared(
        Object.keys(data.result)[0],
        data.result.year.sort((a, b) => b - a),
        '',
        true
      )
    }
  })

  document.querySelector('.fitment_shop_btn_mobile').disabled = true
  document.querySelector('.fitment_clear_btn_mobile').style.display = 'none'
}

document.addEventListener('click', function (event) {
  if (event.target.matches('.popular_vehicles_mobile a')) {
    document
      .querySelectorAll('.popular_collection_details_mobile')
      .forEach((element) => element.classList.add('hidden'))

    const vehicle = event.target.textContent
    document
      .querySelectorAll('.popular_collection_details_mobile')
      .forEach((element) => {
        if (vehicle.split(' ').every((i) => element.classList.contains(i))) {
          element.classList.remove('hidden')
        }
      })

    document
      .querySelectorAll('.popular_vehicles_mobile a')
      .forEach((element) => element.classList.remove('active'))
    event.target.classList.add('active')
  }
})

let btnContainerMobileP = document.querySelector('.btn_container_mobile p')
if (btnContainerMobileP) {
  btnContainerMobileP.addEventListener('click', clearFitmentDataMobile)
}

let fimentClearMobile = document.querySelector('.fitment_clear_mobile')
if (fimentClearMobile) {
  fimentClearMobile.addEventListener('click', function () {
    clearFitmentDataMobile()

    if (window.location.href.includes('collections') || window.location.href.includes('search?q=') || window.location.href.includes('products')) {
      location.reload()
    }
  })
}

class StickyHeaderMobile extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header-mobile')
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size'
    this.headerBounds = {}

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky')
    }

    this.currentScrollTop = 0
    this.preventReveal = false
    this.predictiveSearch = this.querySelector('predictive-search')

    this.onScrollHandler = this.onScroll.bind(this)
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.addEventListener('scroll', this.onScrollHandler, false)

    this.createObserver()
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this.header)
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header')
      if (this.preventHide) return
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header')
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this))
      } else {
        window.clearTimeout(this.isScrolling)

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false
        }, 66)

        requestAnimationFrame(this.hide.bind(this))
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header')
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this.headerIsAlwaysSticky) return
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    )
    this.header.style.top = ''
  }

  reveal() {
    const headerMultiSite = document.querySelector(
      '.section-header-nav-multi-site'
    )
    if (this.headerIsAlwaysSticky) return
    this.header.classList.add('shopify-section-header-sticky', 'animate')
    this.header.classList.remove('shopify-section-header-hidden')
    if (headerMultiSite) {
      const height = headerMultiSite.offsetHeight
      this.header.style.top = `${height}px`
    }
  }

  reset() {
    if (this.headerIsAlwaysSticky) return
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    )
    this.header.style.top = ''
  }
}

customElements.define('sticky-header-mobile', StickyHeaderMobile)
